import { api } from "@/frontend/services/api";
import type {
  TournamentsPaginatedResponseDTO,
  TournamentResponseDTO,
  CreateTournamentRequestDTO,
  UpdateTournamentRequestDTO,
  ApiResponse,
  PaginationRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/tournaments/private";

export const tournamentService = {
  getPaginate: (params?: PaginationRequestDTO) => {
    return api.getWithParams<ApiResponse<TournamentsPaginatedResponseDTO>>(BASE_URL, params);
  },
  getById: (id?: string) => api.get<ApiResponse<TournamentResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreateTournamentRequestDTO) => api.post<ApiResponse<TournamentResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateTournamentRequestDTO) => api.put<ApiResponse<TournamentResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) => api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
